import React, { useContext, useEffect, useState } from "react";
import { groupListApi } from "../../../../../../api/Api";
import { Fullscreen, Refresh } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import { AppThemeContext } from "../../../../../../context/AppThemeContext";
import BusinessGroupForm from "../../businessGroupFrom/BusinessGroupForm";
import BusinessGroupListUpdate from "../businessGroupListUpdate/BusinessGroupListUpdate";
import { styled } from "@mui/material";
import BusinessGroupListDelete from "../businessGroupListDelete/BusinessGroupListDelete";

export default function BusinessGroupListData() {
    const { PrimaryColor } = useContext(AppThemeContext);
    const [logData, setLogData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [searchQuery, setSearchQuery] = useState("");
    const navigate = useNavigate();

    const [showModal, setShowModal] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [showForm, setShowForm] = useState(false); // ✅ Form Add modal state

    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [users, setUsers] = useState([]); // Assume users data is managed here

    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 5;

    const [credentials] = useState({
        User_ID: localStorage.getItem("business_LOGIN_ID") || "",
        SKey: localStorage.getItem("business_SS_KEY") || "",
    });

    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);
        try {
            const res = await groupListApi(credentials);
            if (res?.GROUP_LIST && Array.isArray(res.GROUP_LIST)) {
                setLogData(res.GROUP_LIST);
                setFilteredData(res.GROUP_LIST);
            } else {
                setLogData([]);
                setFilteredData([]);
            }
        } catch (err) {
            console.error("Error fetching data:", err);
            setError("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [credentials.User_ID]);

    const handleSearch = () => {
        const filtered = logData.filter((item) =>
            Object.values(item).join(" ").toLowerCase().includes(searchQuery.toLowerCase())
        );
        setFilteredData(filtered);
        setCurrentPage(1);
    };

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = filteredData.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(filteredData.length / rowsPerPage);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleClick = (groupId, CompanyName) => {
        navigate("businessGroupRight", { state: { groupId, CompanyName } });
    };

    const handleOpenModal = (userData) => {
        setSelectedUser(userData);
        setShowModal(true);
    };

    const handleClose = () => {
        setShowModal(false);
        setSelectedUser(null);
    };

    const handleCloseForm = () => {
        setShowForm(false);
    };






    // Open Delete Modal
    const handleOpenDeleteModal = (userData) => {
        console.log("Opening delete modal for:", userData); // ✅ Debugging
        setSelectedUser(userData);
        setShowDeleteModal(true);
    };




    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setSelectedUser(null);
    };

    // Handle successful deletion
    const handleDeleteSuccess = (deletedUserId) => {
        setFilteredData(filteredData.filter(user => user.Group_id !== deletedUserId));
        setLogData(logData.filter(user => user.Group_id !== deletedUserId));
    };

    const style = {
        maxWidth: "100px",
        padding: "4px 8px",
        fontSize: "0.9rem",
        borderRadius: "7px"
    };

    return (
        <>
            <div className="w-100">
                <div className="row">
                    <div className="col-md-12">
                        {loading && <p>Loading...</p>}
                        {error && <p style={{ color: "red" }}>{error}</p>}
                        <div className="w-100" style={{ backgroundColor: "#f8f9fa", borderBottom: "2px solid #dee2e6" }}>
                            <div className="d-flex justify-content-between align-items-center px-0">
                                <h6 style={{ margin: 0, fontWeight: "bold", color: "#343a40" }}>Group List</h6>

                                <div className="d-flex align-items-center">
                                    <button
                                        className="text-white mx-2"
                                        onClick={() => setShowForm(true)} // ✅ Show form modal
                                        style={{ maxWidth: "100px", padding: "4px 8px", fontSize: "0.9rem", borderRadius: "7px", backgroundColor: PrimaryColor }}
                                    >
                                        Add Group
                                    </button>

                                    <input
                                        type="text"
                                        className="form-control form-control-sm me-2"
                                        placeholder="Search..."
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                        style={{ maxWidth: "120px", borderRadius: "7px" }}
                                    />
                                    <button
                                        className="btn-primary btn-sm text-white"
                                        onClick={handleSearch}
                                        style={style}
                                    >
                                        Search
                                    </button>
                                    <IconButton onClick={fetchLogData}>
                                        <Refresh />
                                    </IconButton>
                                    <IconButton>
                                        <Fullscreen />
                                    </IconButton>
                                </div>
                            </div>
                        </div>

                        <div className="table-responsive" style={{ border: "1px solid #dee2e6", borderTop: "none" }}>
                            <table className="table table-striped">
                                <thead>
                                    <tr>
                                        <th>Sn</th>
                                        <th>Company Name/Group Name</th>
                                        <th>ID</th>
                                        <th>Address</th>
                                        <th>Password</th>
                                        <th>Email</th>
                                        <th>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentRows.length > 0 ? (
                                        currentRows.map((log, index) => (
                                            <tr key={index}>
                                                <td>{indexOfFirstRow + index + 1}</td>
                                                <td className="text-primary" style={{ cursor: "pointer" }} onClick={() => handleClick(log.Group_id, log.CompanyName)}>
                                                    {log.CompanyName}
                                                </td>
                                                <td>
                                                    {log.Group_id}
                                                </td>
                                                <td>{log.Address}</td>
                                                <td>{log.Password}</td>
                                                <td>{log.Email}</td>
                                                {/* <td><button className="btn btn-primary" style={style} onClick={() => handleOpenModal(log)}>Update</button> <button className="btn btn-danger" style={style} onClick={() => handleOpenDeleteModal(log)}>Delete</button></td> */}
                                                <td><button className="btn btn-primary" style={style} onClick={() => handleOpenModal(log)}>Update</button> </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td colSpan="6">No data available</td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="d-flex justify-content-center my-3">
                            <button
                                className="btn btn-secondary btn-sm mx-1"
                                onClick={() => handlePageChange(currentPage - 1)}
                                disabled={currentPage === 1}

                                style={{
                                    height: "28px", // Adjust the height
                                    backgroundColor: PrimaryColor,
                                    padding: "2px",   // Optional: Remove padding for further size reduction
                                    fontSize: "10px", // Optional: Reduce font size if needed
                                }}
                            >
                                Previous
                            </button>
                            {[...Array(totalPages).keys()].map((num) => (
                                <button
                                    key={num}
                                    className={`btn btn-sm mx-1 ${currentPage === num + 1
                                        ? "btn-primary"
                                        : "btn-outline-primary"
                                        }`}
                                    onClick={() => handlePageChange(num + 1)}

                                    style={{
                                        height: "20px", // Adjust the height
                                        width: "20px",  // Adjust the width
                                        padding: "0",   // Optional: Remove padding for further size reduction
                                        fontSize: "12px", // Optional: Reduce font size if needed
                                    }}
                                >
                                    {num + 1}
                                </button>
                            ))}
                            <button
                                className="btn btn-secondary btn-sm mx-1"
                                onClick={() => handlePageChange(currentPage + 1)}
                                disabled={currentPage === totalPages}

                                style={{
                                    height: "28px", // Adjust the height
                                    backgroundColor: PrimaryColor,
                                    padding: "2px",   // Optional: Remove padding for further size reduction
                                    fontSize: "10px", // Optional: Reduce font size if needed
                                }}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Update Group Modal */}
            {showModal && selectedUser && (
                <BusinessGroupListUpdate
                    show={showModal}
                    handleClose={handleClose}
                    userData={selectedUser}
                />
            )}

            {/* Add Group Form Modal */}
            {showForm && (
                <BusinessGroupForm
                    show={showForm}
                    handleClose={handleCloseForm} // ✅ Form modal close function
                />
            )}

            {/* Delete Modal */}
            {showDeleteModal && selectedUser && (
                <BusinessGroupListDelete
                    show={showDeleteModal}
                    handleClose={handleCloseDeleteModal}
                    userId={selectedUser.Group_id} // ✅ Pass Group_id instead of userId
                    handleDeleteSuccess={handleDeleteSuccess}
                    userData={selectedUser}
                />
            )}

        </>
    );
}
